import { sha256 } from 'js-sha256';

import { fg } from '@atlaskit/platform-feature-flags';

import { QueryIntent } from './constants';

export const sha256Hash = (str: string): string => sha256(str);

export const extractUrlHostname = (sourceUrl: string) => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};

export const isHello = (cloudId: string): boolean => {
	return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};

export const getAnswerCardType = (
	isReadingAids: boolean,
	smartAnswersRoute?: QueryIntent,
): string => {
	if (isReadingAids) {
		return 'definition';
	}

	if (fg('kd_improve_sain_error_instrumentation')) {
		switch (smartAnswersRoute) {
			case QueryIntent.PERSON:
				return 'people';
			case QueryIntent.TEAM:
				return 'team';
			case QueryIntent.AGENT:
				return 'agent';
			case QueryIntent.DATE:
				return 'date';
			case QueryIntent.LOCATION:
				return 'location';
			case QueryIntent.TOPIC:
				return 'topic';
			case QueryIntent.JIRA_NATURAL_LANGUAGE_QUERY:
				return 'jira_nl_to_jql';
			case QueryIntent.JIRA_ISSUE:
				return 'jira_issue';
			case QueryIntent.NAVIGATIONAL:
				return 'navigational';
			case QueryIntent.NONE:
				return 'none';
			case QueryIntent.DEFAULT:
				return 'default';
			case QueryIntent.NATURAL_LANGUAGE_QUERY:
			case QueryIntent.KEYWORD_OR_ACRONYM:
			default:
				return 'SAIN';
		}
	}

	switch (smartAnswersRoute) {
		case QueryIntent.PERSON:
			return 'people';
		case QueryIntent.TEAM:
			return 'team';
		case QueryIntent.AGENT:
			return 'agent';
		case QueryIntent.DATE:
			return 'date';
		case QueryIntent.LOCATION:
			return 'location';
		case QueryIntent.TOPIC:
			return 'topic';
		default:
			return 'SAIN';
	}
};
